'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResponsiveProgressiveImage = require('./ResponsiveProgressiveImage');

var _ResponsiveProgressiveImage2 = _interopRequireDefault(_ResponsiveProgressiveImage);

var _Spinner = require('../loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

require('./OptimisticImage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OptimisticImage = function OptimisticImage(_ref) {
    var imageType = _ref.imageType,
        imageDetails = _ref.imageDetails,
        attachmentDetails = _ref.attachmentDetails,
        alt = _ref.alt,
        size = _ref.size,
        onImageLoadCb = _ref.onImageLoadCb,
        children = _ref.children,
        forcedHeight = _ref.forcedHeight,
        forcedWidth = _ref.forcedWidth;

    if (!imageDetails && !(attachmentDetails && attachmentDetails.get('data'))) return null;

    var attachmentError = attachmentDetails && attachmentDetails.get('error');
    var uploadedFileData = attachmentDetails && attachmentDetails.get('data');
    var showSpinner = !!uploadedFileData && !attachmentError;

    // If we don't have the uploaded file data, then we should not show the progressive image as it might
    // not be completely downloaded.  But we do want to add it to the page so that it can be retrieved in the
    // background
    var showProgressiveImage = !uploadedFileData;

    var progressiveImage = null;
    // If we have image details render the progressive image to ensure its lifecycle hooks fire, even if display
    // is 'none'
    if (imageDetails) {
        var style = {
            display: showProgressiveImage ? 'block' : 'none'
        };

        progressiveImage = _react2.default.createElement(_ResponsiveProgressiveImage2.default, {
            imageType: imageType,
            imageDetails: imageDetails,
            style: style,
            alt: alt,
            size: size,
            onImageLoadCb: onImageLoadCb,
            forcedHeight: forcedHeight,
            forcedWidth: forcedWidth });
    }

    // If we have file data in the attachment then display the attachment image
    var attachmentDataImage = uploadedFileData ? _react2.default.createElement('img', { className: 'attachment-image', src: uploadedFileData, width: forcedWidth || size, height: forcedHeight }) : null;

    return _react2.default.createElement(
        'div',
        { className: 'OptimisticImage' },
        _react2.default.createElement(_Spinner2.default, { show: showSpinner }),
        attachmentDataImage,
        progressiveImage,
        children
    );
};

// Styles


// Components
// Lib


OptimisticImage.propTypes = {
    imageType: _propTypes2.default.string.isRequired,
    imageDetails: _propTypes2.default.object,
    attachmentDetails: _propTypes2.default.object,
    onImageLoadCb: _propTypes2.default.func,
    alt: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
    size: _propTypes2.default.number.isRequired,
    forcedWidth: _propTypes2.default.number,
    forcedHeight: _propTypes2.default.number
};

exports.default = OptimisticImage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/images/OptimisticImage.js
// module id = 1899
// module chunks = 0